export default __webpack_public_path__ + "static/media/sud-wallpaper.66c27183.jpg";